import { useEffect } from "react";
import useAuth from "../../hooks/useAuth";
import { baseURL, handleNotOkHttpResponse } from "../../utils/misc";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { isSinglePageActive } from "../../utils/daynamicNavigation";
import Preloader from "../common/Preloader";
import { isoToDate } from "../../utils/helpers";
import { Button, Modal } from "react-bootstrap";

function ManufacturingTable({ manufacturingRecords, allowEdit }) {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [showPreloader, setShowPreloader] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);

    const profileMenuItems = [
        {
            id: 1,
            name: "View",
            icon: "icon-eye1",
            onClick: (process) => {
                handleShowViewModal(process);
            },
        },
        {
            id: 1,
            name: "Edit",
            icon: "icon-edit1",
            routerPath: "/manufacturingrecord/edit",
            authType: 'admin',
        },
        {
            id: 3,
            name: "Delete",
            icon: "icon-delete",
            onClick: (process) => {
                handleShowDeleteModal(process);
            },
            authType: 'admin',
        }
    ];

    // Define the path pattern for user profiles
    const $ = require("jquery");

    useEffect(() => {
        if (manufacturingRecords && manufacturingRecords.length > 0) {
            //Initialize DataTable when users are available
            $(document).ready(function () {
                const dataTable = $("#data-table").DataTable();

                // Destroy DataTable if it exists
                if (dataTable) {
                    dataTable.destroy();
                }

                $("#data-table").DataTable({
                    // Add any required DataTable options here
                    columnDefs: [
                        // { width: "12%", targets: 1 },
                        // { width: "12%", targets: 3 }
                    ]
                });
            });
        }
    }, [manufacturingRecords, $]);

    const handleShowViewModal = (record) => {
        setSelectedRecord(record);
        setShowViewModal(true);
    };

    const handleCloseViewModal = () => {
        setShowViewModal(false);
        setSelectedRecord(null);
    };

    const handleShowDeleteModal = (record) => {
        setSelectedRecord(record);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setSelectedRecord(null);
    };

    const handleRemoveManufacturingRecord = async () => {
        if (!(user && user.user.token)) {
            navigate('/login');
            toast.warn("You seem to have lost your access token. Please try again later.");
            return;
        }

        setShowPreloader(true);
        try {
            if (!selectedRecord) {
                console.error('No selected Record');
                return;
            }

            const requestOptions = {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${user.user.token}`,
                },
                redirect: "follow",
            };

            const response = await fetch(`${baseURL}/manufacturingrecords/${selectedRecord.id}`, requestOptions);
            if (response.ok) {
                toast.success("Manufacturing Record removed successfully");
                handleCloseDeleteModal();
                setShowPreloader(true);
                window.location.reload();
            } else {
                handleNotOkHttpResponse(response);
                return false;
            }
        } catch (error) {
            console.error("Error on removing Manufacturing Record:", error.message);
        } finally {
            setShowPreloader(false);
        }
    };

    return (
        <>
            <Preloader show={showPreloader} />
            <div className="card-body pt-0">
                <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">

                        <div className="table-responsive">
                            <table id="data-table" className="table custom-table">
                                <thead className="thead-dark">
                                    <tr>
                                        <th>Code</th>
                                        <th>Date</th>
                                        <th>GLN</th>
                                        <th>Batch Number</th>
                                        <th>Product Name</th>
                                        <th>Quantity Produced</th>
                                        <th>Fda Registration Code</th>
                                        <th>Performed By</th>
                                        <th>Supervised By</th>
                                        <th><div className="float-end">Actions</div></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {manufacturingRecords && manufacturingRecords.length > 0 ? manufacturingRecords.map((packHouseRecord, index) => (
                                        <tr key={index}>
                                            <td>{packHouseRecord.code ? packHouseRecord.code : '--'}</td>
                                            <td style={{ width: '5rem' }}>{isoToDate(packHouseRecord.date)}</td>
                                            <td>{packHouseRecord.gln ? packHouseRecord.gln : '--'}</td>
                                            <td>{packHouseRecord.batchNumber}</td>
                                            <td>{packHouseRecord.productName}</td>
                                            <td>{packHouseRecord.quantityProduced} {packHouseRecord.quantityUnit}</td>
                                            <td>{packHouseRecord.fdaRegistrationCode}</td>
                                            <td>{packHouseRecord.performedBy}</td>
                                            <td>{packHouseRecord.supervisedBy}</td>
                                            <td className="">
                                                <ul>
                                                    <li className="user_setting float-end" style={{ listStyle: "none" }}>
                                                        <div className="dropdown">
                                                            <Link
                                                                className="btn btn-secondary dropdown-toggle dn-1199 ms-2"
                                                                role="button"
                                                                href="#"
                                                                id={"dropdownMenuLink" + packHouseRecord.id}
                                                                data-bs-toggle="dropdown"
                                                            >
                                                                Actions <i className="fa fa-caret-down"></i>
                                                            </Link>
                                                            <ul
                                                                className="dropdown-menu"
                                                                aria-labelledby={"dropdownMenuLink" + packHouseRecord.id}
                                                            >
                                                                {profileMenuItems.map((actionMenuItem) => (
                                                                    <>
                                                                        {(!actionMenuItem.authType || (actionMenuItem.authType === "admin" && allowEdit)) &&
                                                                            <li key={packHouseRecord.id + '-' + actionMenuItem.id}>
                                                                                {actionMenuItem.onClick ? (
                                                                                    <Link
                                                                                        href="#"
                                                                                        className="dropdown-item"
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault(); // Prevent default anchor behavior
                                                                                            actionMenuItem.onClick(packHouseRecord);
                                                                                        }}
                                                                                        style={
                                                                                            isSinglePageActive(`${actionMenuItem.routerPath}`, navigate.pathname)
                                                                                                ? { color: "#ff5a5f" }
                                                                                                : undefined
                                                                                        }
                                                                                    >
                                                                                        <i className={actionMenuItem.icon}></i>&nbsp;&nbsp;{actionMenuItem.name}
                                                                                    </Link>
                                                                                ) : (
                                                                                    <Link
                                                                                        to={actionMenuItem.routerPath + "/" + packHouseRecord.id} // Changed href to to
                                                                                        className="dropdown-item"
                                                                                        style={
                                                                                            isSinglePageActive(`${actionMenuItem.routerPath}`, navigate.pathname)
                                                                                                ? { color: "#ff5a5f" }
                                                                                                : undefined
                                                                                        }
                                                                                    >
                                                                                        <i className={actionMenuItem.icon}></i>&nbsp;&nbsp;{actionMenuItem.name}
                                                                                    </Link>
                                                                                )}
                                                                            </li>
                                                                        }
                                                                    </>
                                                                ))}

                                                            </ul>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                    )) : (<tr><td colSpan="7" className="text-center"><em>No data available!</em></td></tr>)}
                                </tbody>
                            </table>
                            {/* Delete Modal */}
                            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                                <Modal.Header closeButton style={{ backgroundColor: 'rgb(36, 50, 74)' }}>
                                    <Modal.Title style={{ color: 'white' }}>Delete Manufacturing</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p className="mb-4">
                                        Are you sure you want to delete this Manufacturing record?
                                    </p>
                                </Modal.Body>
                                <Modal.Footer style={{ borderTop: 'none' }}>
                                    <Button variant="secondary" style={{ color: '#fff', backgroundColor: '#6c757d', border: 'none' }} onClick={handleCloseDeleteModal}>
                                        Cancel
                                    </Button>
                                    <Button variant="danger" style={{ color: '#fff', backgroundColor: '#dc3545', border: 'none' }} onClick={handleRemoveManufacturingRecord}>
                                        Delete
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            {/* View Modal */}
                            <Modal size="xl" show={showViewModal} onHide={handleCloseViewModal}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Manufacturing Record Details</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    {selectedRecord ? (
                                        <div className="formView">
                                            <p><strong>Code:</strong> {selectedRecord.code ? selectedRecord.code : "N/A"}</p>
                                            <p><strong>GLN:</strong> {selectedRecord.gln}</p>
                                            <p><strong>Date:</strong> {isoToDate(selectedRecord.date)}</p>
                                            <p><strong>Product Name:</strong> {selectedRecord.productName}</p>
                                            <p><strong>Product GTIN:</strong> {selectedRecord.gtin}</p>
                                            <p><strong>Quantity Produced:</strong> {selectedRecord.quantityProduced} {selectedRecord.quantityUnit}</p>
                                            <p><strong>Equipment Used:</strong> {selectedRecord.equipmentUsed}</p>
                                            <p><strong>Performed By:</strong> {selectedRecord.performedBy}</p>
                                            <p><strong>Supervised By:</strong> {selectedRecord.supervisedBy}</p>
                                            <p><strong>Quality Checks:</strong> {selectedRecord.qualityChecks}</p>
                                            <p><strong>Issues Identified:</strong> {selectedRecord.issuesIdentified}</p>
                                            <p><strong>Corrective Actions:</strong> {selectedRecord.correctiveActions}</p>
                                            <p><strong>Packaging Details:</strong> {selectedRecord.packagingDetails}</p>
                                            <p><strong>Batch Number:</strong> {selectedRecord.batchNumber}</p>
                                            <p><strong>FDA Registration Code:</strong> {selectedRecord.fdaRegistrationCode}</p>
                                            <p><strong>Shelf Life:</strong> {selectedRecord.shelfLife} {selectedRecord.shelfLifeUnit}</p>

                                            {/* Environmental Conditions */}
                                            <hr />
                                            <h4>Manufacturing Processes</h4>
                                            {selectedRecord.manufacturingProcesses && selectedRecord.manufacturingProcesses.length > 0 ? (<>
                                                <div className="table-responsive">
                                                    <table id="data-table" className="table custom-table">
                                                        <thead className="thead-dark">
                                                            <tr>
                                                                <th>Process Name</th>
                                                                <th>Start Date</th>
                                                                <th>End Date</th>
                                                                <th>Tools And Materials Used</th>
                                                                <th>Quantity</th>
                                                                <th>Performed By</th>
                                                                <th>Supervised By</th>
                                                                <th>Quality Checks</th>
                                                                <th>Issues Identified</th>
                                                                <th>Corrective Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {selectedRecord.manufacturingProcesses.map((process, index) => (
                                                                <tr key={process.id || index}>
                                                                    <td>{process.processName}</td>
                                                                    <td>{isoToDate(process.startDate)}</td>
                                                                    <td>{isoToDate(process.endDate)}</td>
                                                                    <td>{process.toolsAndMaterialsUsed}</td>
                                                                    <td>{process.quantityUsed} {process.quantityUnit}</td>
                                                                    <td>{process.performedBy}</td>
                                                                    <td>{process.supervisedBy}</td>
                                                                    <td>{process.qualityChecks}</td>
                                                                    <td>{process.issuesIdentified}</td>
                                                                    <td>{process.correctiveActions}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </>
                                            ) : (
                                                <p>No manufacturing processes data available.</p>
                                            )}
                                        </div>
                                    ) : (
                                        <p>No record selected.</p>
                                    )}

                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleCloseViewModal}>
                                        Close
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ManufacturingTable;